import { ILanguage } from '../../interfaces/ILanguage'

export const en: ILanguage = {
   '365Robust': '365Robust',
   Loading: 'Loading...',
   LoadingActivities: 'Loading activities...',
   Of: 'of',

   MobileViewUnderConstruction: 'The mobile version of 365Robust is currently under development.',
   PleaseUseComputerToAccessTheApplication: 'We kindly ask you to use a desktop or laptop computer to access the application.',
   KindRegards365RobustTeam: 'Kind regards, The 365Robust team.',

   // Authentication
   WelcomeTo: 'Welcome to',
   SignIn: 'Sign in',
   SignOut: 'Sign out',
   Dashboard: 'Dashboard',
   NotAuthorized: 'Not authorized',
   ShowQRCode: 'Show QR code',
   IdentifyWithBankId: 'Identifiera dig med BankID',
   BankIdInstructions: 'Start the BankID app on your mobile or tablet and press "Scan QR code"',
   QRCodeAltText: 'QR code, scan with BankID app, hold your phone in portrait mode 40cm from the screen. Click to enter full screen',
   ExitFullScreen: 'Exit full screen',
   SecondsLeft: 'seconds left',
   QRTimeout: 'QR code timed out',
   SignInWithBankId: 'Sign in with BankID',
   SigningIn: 'Siging in',
   NoAccountRegistered: 'No account found for this personal number',
   TryAgain: 'Try again',
   NoAccessMessage: 'You do not have permission to perform this action.',

   // Bankid user messages
   RFA1: 'Start your BankID app.',
   RFA2: "You don't seem to have the BankID app. Install the app and get a BankID.",
   RFA3: 'The action was cancelled. Please try again.',
   RFA4: 'An identification or signature is already in progress for your personal identity number. Please try again.',
   RFA5: 'Something went wrong. Please try again.',
   RFA6: 'The action was cancelled.',
   RFA8: "The BankID app is not responding. Please check that it's started and that you have internet access. Try again.",
   RFA9: 'Enter your security code in the BankID app and select Identify or Sign.',
   RFA13: 'Trying to start your BankID app.',
   RFA15a:
      'Searching for BankID. Make sure you have a valid BankID on this computer. If you have a BankID on card, please insert the card into your card reader.',
   RFA15b: 'Searching for BankID. Make sure you have a valid BankID on this device.',
   RFA16: 'Your BankID is blocked or too old. Please use another BankID or get a new one from your bank.',
   RFA17a: "You don't seem to have the BankID app/program. Please install it and get a BankID from your bank.",
   RFA17b: 'Failed to scan the QR code. Start the BankID app and scan the QR code.',
   RFA19: 'Would you like to use BankID on this computer, or a Mobile BankID?',
   RFA20: 'Do you want to use BankID on this device or another device?',
   RFA21: 'An identification or signing is in progress.',
   RFA22: 'Something went wrong. Please try again.',
   RFA23: 'Take a photo of, and scan, your ID document with the BankID app.',
   UpdateToLatestVersionOfBankId: 'Please update to the latest version of the BankID app to continue.',

   // Organisation
   Organisation: 'Organisation',
   OrganisationalData: 'Organisational data',
   OrganisationNumber: 'Organisation number',
   CompanyName: 'Company name',
   OrganisationSize: 'Organisation size',
   OrganisationType: 'Organisation type',
   SNI: 'SNI',
   All: 'All',
   OrganisationDetails: 'Organisation details',
   InvoiceDetails: 'Invoice details',
   Invocing: 'Invoicing',
   OtherInvoiceDetails: 'Other invoice details',
   ZipNumberMustBe5Digits: 'Zip code must be 5 digits (XXX XX)',
   InvalidPhoneNumber: 'Invalid phone number',

   // User
   AccountInformation: 'Account information',
   Account: 'Account',
   FirstName: 'First name',
   LastName: 'Last name',
   Email: 'E-mail',
   OrganizationalAffiliation: 'Organizational affiliation',
   JobTitle: 'Job title',
   UserType: 'User type',
   Roles: 'Roles',
   PersonalIdentityNumber: 'Personal identity number',
   PersonalIdentityNumberFormat: 'YYYYMMDD-XXXX',
   PersonalIdentityNumberMustBe12Digits: 'Personal number must be 12 digits (YYYYMMDD-XXXX)',
   AtleastOneUserMustBeSystemAdministrator: 'At least one user must be a System Administrator',
   PaymentIsMadeViaMonthlyInvoicing: 'Payment is made via monthly invoicing',

   // Button
   Next: 'Next',
   Add: 'Add',
   Finish: 'Finish',
   Cancel: 'Cancel',
   Continue: 'Continue',
   Save: 'Save',
   Create: 'Create',
   Update: 'Update',
   Delete: 'Delete',
   ReadMore: 'Read more',
   Close: 'Close',
   Complete: 'Complete',
   Determine: 'Determine',
   Back: 'Back',
   ExportToExcel: 'Export to Excel',
   ExportLawlistToExcel: 'Export lawlist to Excel',
   Criteria: 'Criteria',
   ResetDecision: 'Reset decision',
   ResetDecisionConfirmationMessage: 'Are you sure you want to reset the action decision? This action cannot be undone.',
   ResetAnswer: 'Reset answer',
   ResetAnswerConfirmationMessage:
      'Are you sure you want to reset the answer? If the question has a linked action plan, it will be deleted. This action cannot be undone.',
   AnswerReset: 'Answer reset',
   CouldNotResetAnswer: 'Could not reset the answer',
   AddProtectedAsset: 'Add protected asset',
   AddOrganisationGoal: 'Add organisational goal',
   NotNow: 'Not now',

   // Roles
   ProcessOwner: 'Process owner',
   Owner: 'Owner',
   RiskOwner: 'Risk owner',
   AnalysisLeader: 'Analysis leader',

   // Billing
   BillingData: 'Billing data',
   InvoiceReference: 'Invoice reference',
   InvoiceAddress: 'Invoice address',
   PostalCode: 'Postal code',
   County: 'County',
   PhoneNumber: 'Phone number',

   // Workplace
   Workplace: 'Workplace',
   Workplaces: 'Workplaces',
   TheWorkplace: 'The workplace',
   WorkplaceName: 'Name of workplace',
   OrganisationForm: 'Organisation type',
   SNICodes: 'SNI codes',
   WorkplaceDescription: 'Workplace description',
   VisitingAdress: 'Visiting address',
   CFAR: 'CFAR-no',
   InvalidCfar: 'Only digits are allowed',
   CfarLengthMessage: 'CFAR must be exactly 8 digits',
   NumberOfEmployees: 'Number of employees',
   NewWorkplace: 'New workplace',
   Address: 'Address',
   TheWorkplaceIsInUseAndCannotBeDeleted: 'The workplace is in use by another item and cannot be deleted.',
   OnlySystemAdministratorCanDeleteWorkplaces: 'Only system administrator can delete workplaces',
   TimeToCreateYourFirstWorkplace: 'Time to create your first workplace',

   // StartUpWizard
   CheckAndVerifyOrganisationData: 'Check and verify organisation details',
   CheckAndVerifyUserData: 'Kontrollera och verify user details',
   User: 'User',
   Users: 'Users',
   SystemAdministrator: 'System administrator',
   OrganisationAffiliation: 'Organisationaffiliation',

   // ProtectedAssets
   ProtectedAssets: 'Protected assets',
   ProtectedAsset: 'Protected asset',
   TheProtectedAsset: 'The protected asset',
   Asset: 'Asset',
   'ProtectedAsset/OrganisationalGoal': 'Protected asset/Organisational goal',
   WorkplaceAffiliation: 'Workplace affiliation',
   DescriptionOfAsset: 'Description of asset',
   Description: 'Description',
   ProtectedAssetValuation: 'Asset valuation',
   AddedAssets: 'Added assets',
   NewDemandAssessment: 'New demand assessment',
   OngoingDemandAssessments: 'Ongoing demand assessments',
   ConcludedDemandAssessments: 'Concluded demand assessments',
   AccessAffectsFollowingProcesses: 'Access affects the following processes',
   MotivationAndStand: 'Motivation and stand',
   TimeToCreateYourFirstItem: 'Time to create your first {{Item}}',
   NoConcludedItems: 'There are no completed {{Item}}',
   OngoingItem: 'Ongoing {{Item}}',
   ConcludedItem: 'Completed {{Item}}',
   NewItem: 'New {{Item}}',
   EditItem: 'Edit {{Item}}',
   DeleteItem: 'Delete {{Item}}',
   NameOfItem: 'Name of {{Item}}',
   DescriptionOfItem: 'Description of {{Item}}',
   ValuationOfItem: 'Valuation of {{Item}}',
   Valuation: 'Valuation',
   ValuationDate: 'Valuation date',
   Name: 'Name',
   NoProtectedAssetOrGoal: 'No protected asset or organisational goal is registered',
   NoProtectedAssetOrGoalInfo: 'There is no protected asset or organisational goal registered. These can be added under the organisation menu',
   DoYouWantToAddNow: 'Do you want to add one now?',
   TheProtectedAssetIsInUseAndCannotBeDeleted: 'The protected asset is in use and cannot be deleted',
   TheOrganisationalGoalIsInUseAndCannotBeDeleted: 'The organisational goal is in use and cannot be deleted',
   OnlySystemAdministratorCanDeleteProtectedAssets: 'Only a system administrator can delete protected assets',
   OnlySystemAdministratorCanDeleteOrganisationalGoals: 'Only a system administrator can delete organisational goals',

   // Organisational goals
   NewOrganisationalGoal: 'New organisational goal',
   OrganisationalGoals: 'Organisational goals',
   OrganisationalGoal: 'Organisational goal',
   TheOrganisationalGoal: 'The organisational goal',
   TheGoal: 'The Goal',

   // ComplianceOfDemands
   ComplianceOfDemands: 'Compliance of demands',
   LeadershipPerspective: 'Leadership perspective',
   Subject: 'Subject',
   InformationManagement: 'Information management',
   StartOfAssessment: 'Start of assessment',
   EndOfAssessment: 'End of assessment',
   Comment: 'Comment',
   CommentFromDemandCompliance: 'Comment from demand compliance',
   CreateAssessment: 'Create assessment',
   Process: 'Process',
   ProcessAffiliation: 'Process affiliation',
   CreatingDemandAssessment: 'Creating demand assessment...',
   DemandAssessmentCreated: 'The demand assessment is created',
   ThisCanTakeAMoment: 'This can take a moment. Please wait and keep the device on.',
   ClickContinueToGoToAssessment: "Click 'Continue' to open your assessment",
   Information: 'Information',
   DemandAnalysis: 'Demand analysis',
   Responsible: 'Responsible',
   ActionPlan: 'Action plan',
   DemandAssessment: 'Demand assessment',
   CompleteDemandAssessment: 'Complete demand assessment',
   DeleteDemandAssessment: 'Delete demand assessment',
   CompleteDemandAssessmentConfirmationMessage:
      'Are you sure you want to complete the demand assessment? The action cannot be undone when it has been completed.',
   DeleteDemandAssessmentConfirmationMessage: 'Are you sure you want to delete the demand assessment? The action cannot be undone when it has been completed.',
   AllAnswered: 'Answered',
   NoConcludedDemandAssessments: 'There are no concluded demand assessments',
   TimeToCreateYourFirstDemandAssessment: 'Time to create your first demand assessment',
   AllProcesses: 'All processes',
   ShowHeadings: 'Show headings',
   'No.': 'No.',
   Question: 'Question',
   QuestionAnswered: 'Question answered',
   CouldNotAnswerQuestion: 'Could not answer question',
   CompleteDemandAnalysisConfirmationText:
      'Are you sure you want to complete demand analysis for {{process}}? You will not be able to update the answers to the questions and action plans will be created',
   EditDemandAssessment: 'Edit demand assessment',
   Edit: 'Edit',
   ProposedAction: 'Proposed action',
   BackgroundInformationForTheQuestion: 'Background information for the question',
   BackgroundInformation: 'Background information',
   TipFrom365Robust: '365Robust tips',
   OriginDemandForTheQuestion: 'Origin demand for the question',
   OriginDemand: 'Origin demand',
   Source: 'Source',
   DemandAssessmentCompleted: 'Demand assessment successfully completed',
   CouldNotCompleteDemandAssessment: 'Could not complete the demand assessment',
   CouldNotUpdateDemandAssessment: 'Could not update demand assessment',
   AssessmentName: 'Name of assessment',
   NoAvailableInformation: 'There is no information available at this time',
   EstimatedCost: 'Estimated cost for action',
   EstimatedCostShort: 'Estimated cost',
   TotalEstimatedCost: 'Total estimated cost',
   BudgetedCost: 'Budgeterad cost',
   TotalBudgetedCost: 'Total budgeted cost',
   ProcessOwnersForDemandAssessment: 'Process owners for demand assessment',
   ProcessOwnerForDemandAssessmentText:
      'Select an existing user or enter a custom name. Active users will be able to answer questions. Names without associated users will only be answerable by administrators.',
   NotIncluded: 'Not included',
   Included: 'Included',
   ProcessWithProcessowner: 'Process with processowner',
   DeleteDemandAssessmentNoAccessMessage: 'You do not have permission to delete the demand assessment',
   DemandLevel: 'Demand level',

   // Report
   Report: 'Report',
   AnsweredQuestionReport: 'Answered questions - Report',
   AnsweredQuestions: 'Answered questions',
   TotalNumber: 'Total number',
   NumberOfAnswered: 'Number of answered',
   Chart: 'Chart',
   List: 'List',

   // Actionplans
   NoActionPlansCreatedForDemandAssessment: 'The demand analysis must be determined per process before an action plan is created for the process',
   NoActionPlansCreatedForFinancialYear: 'A risk management plan will be created if a proposed action is created for a cost.',
   NoActionPlansRequiredForThisItem: 'No actions required for this {{Item}}.',
   NoActionPlansRequiredForThisFinancialYear: 'No actions required for this financial year.',
   DemandAssessmentCanBeCompleted: 'The demand assessment can be completed',
   RiskAssessmentCanBeCompleted: 'The risk assessment can be completed',
   ComplianceLevel: 'Level of compliance',
   DecisionOnAction: 'Decision on action',
   NoActionShallBeTaken: 'No actions will be taken',
   ResponsibleOfAction: 'Responsible',
   Priority: 'Priority',
   ID: 'ID',
   AnsweredBy: 'Answered by',
   StartAction: 'Start action',
   CompleteAction: 'Complete action',
   ActionDecidedBy: 'Action decided by',
   NoActionsTaken: 'No actions taken',
   ImplementedActions: 'Implemented actions',
   ComplianceLevelAfterCompletedAction: 'Compliance level after implementing action',
   SpecifyCompliance: 'Specify compliance',
   CalculatedOutcome: 'Calculated outcome',
   DecisionStatus: 'Status',
   DecidedMulti: 'Decided',
   TotalNumberOfActions: 'Total number of actions',
   Deadline: 'Deadline',
   PerProcessAndComplianceLevel: 'Per process & compliance level',
   PerComplianceLevel: 'Per compliance level',
   ActionPlanReport: 'Action plan - Report',
   NumberOfActions: 'Number of items',
   AnalysedBy: 'Analysed by',
   ProposedBy: 'Proposed by',

   // Status
   RequiredField: 'This field is required',
   SomethingWentWrong: 'Something went wrong',
   NoMatchingQuestonsFound: 'No matching questions found',
   AssessmentMayHaveBeenCreated: 'Creation took longer than expected. The assessment may have been created — check the list.',
   FetchFailed: 'Could not retrieve data',
   ModifiedBy: 'Modified by',
   Modified: 'Modified',
   CreatedBy: 'Created by',
   CreatedDate: 'Created',
   ItemSuccessfullyCreated: '{{Item}} successfully created',
   ItemSuccessfullySaved: '{{Item}} successfully saved',
   ItemSuccessfullyUpdated: '{{Item}} successfully updated',
   ItemSuccessfullyDeleted: '{{Item}} successfully deleted',
   CouldNotFetchItem: '{{Item}} could not be fetched',
   CouldNotCreateItem: '{{Item}} could not be created',
   CouldNotUpdateItem: '{{Item}} could not be updated',
   CouldNotDeleteItem: '{{Item}} could not be deleted',
   CouldNotFetchData: 'Data could not be fetched',
   Status: 'Status',
   NoDateSet: 'No date set',
   NoValueSet: 'No value set',
   ValidationFailed: 'Validation failed',
   DemandAnalysisCompleted: 'Demand analysis completed',
   CouldNotCompleteDemandAnalysis: 'Something went wrong, could not complete demand analysis',
   NotAnswered: 'Not answered',
   Answered: 'Answered',
   Determined: 'Determined',
   NotDecided: 'Not decided',
   Decided: 'Decided',
   NotStarted: 'Not started',
   Started: 'Started',
   Completed: 'Completed',
   NotToBeAdressed: 'Not to be adressed',
   ErrorMessage: 'Error message',
   NoDataCreatedYet: 'No data created yet.',
   Ongoing: 'Ongoing',
   Concluded: 'Concluded',
   EndDateMustBeAfterStartDate: 'End date must be after start date.',
   EndDateMustBeAfterOrTheSameAsStartDate: 'End date must be after or the same as start date.',
   AnAccountMustBeSelected: 'An account must be selected',
   AtLeastOneWorkplaceMustBeSelected: 'At least one workplace must be selected',
   ItemIsConnectedToItemAndCantBeDeleted: '{{ItemA}} is connected to {{Article}} {{ItemB}} and cannot be deleted',
   OnlySystemAdministratorOrOwnerCanDeleteItem: 'Only a system administrator or owner can delete this {{Item}}',
   OnlySystemAdministratorOrRiskOwnerCanDeleteItem: 'Only a system administrator or risk owner can delete this {{Item}}',
   NoMatchingItemFound: 'No matching {{Item}} found',
   UserNotAllowedToActionItem: 'User is not allowed to {{Action}} on {{Item}}',
   FeatureRequiresUpgrade: 'Upgrade subscription to get access to this feature',
   ValueSetAutomatically: 'This value is set automatically',
   ValueCannotBeChanged: 'This value cannot be changed',
   FeatureRequiresConsequenceRiskOrSimplifiedRisk: 'This feature requires the consequence & probability analysis or simplified risk analysis add-on.',
   ChooseAnAdditionalModuleToEnableThisField: 'Choose an additional module to enable this field',
   TheAdditionalModuleDoesNotHaveClauses: 'The additional module does not have clauses',
   OnlyAdditionalModuleTooltip: 'The assessment will only be based on the requirements of the add-on module.',

   // Riskmanagement:
   CreateAssesment: 'Create assesment',
   RiskAssesment: 'Risk assesment',
   RiskAnalysis: 'Risk analysis',
   RiskManagement: 'Risk management',
   NewRiskAssesment: 'New risk assesment',
   TypeOfRiskAssesment: 'Type of risk analysis',
   NameOfAssesment: 'Name of the assesment',
   'Purpose/Scope': 'Purpose/Scope',
   Limitations: 'Limitations',
   StartOfAssesment: 'Start of assesment',
   EndOfAssesment: 'End of assesment',
   SimplifiedRiskAnalysis: 'Simplified risk analysis',
   ConsequenceAndProbabilityAnalysis: 'Consequence & probability analysis',
   SimplifiedConsequenceProbabilityAnalysis: 'Simplified consequence and probablity analysis',
   SWOTAnalysis: 'SWOT analysis',
   Type: 'Type',
   NoConcludedRiskAssesments: 'There are no completed risk assesments',
   TimeToCreateYourFirstRiskAssesment: 'Time to create your first risk assesment',
   OngoingRiskAssesments: 'Ongoing risk assesments',
   ConcludedRiskAssesments: 'Completed risk assesments',
   CreatingRiskAssesment: 'Creating risk assesment',
   RiskAssesmentCreated: 'The risk assesment has been created',
   RiskIdentifying: '*Risk identifying',
   'RiskAnalysis&Evaluation': 'Risk analysis & evaluation',
   AnalyseEvaluate: 'Analyse & evaluate',
   Identify: 'Identify',
   RiskManagementPlan: 'Risk management plan',
   NewRisk: 'New risk',
   EditRisk: 'Edit risk',
   RiskScenario: 'Risk scenario',
   RiskSource: 'Risk source',
   IdentifyRisk: 'Identify risk',
   WeaknessesOrCurrentProtection: 'Weaknesses or current protection ',
   UnderlyingMotivationAndStand: 'Underlying motivation and stand',
   Consequence: 'Consequence',
   ConsequenceDescription: 'Consequence description',
   NoRisksIdentifiedYet: 'No risks identified yet',
   Risk: 'Risk',
   TheRisk: 'The Risk',
   Title: 'Title',
   CompleteRiskAssessment: 'Complete risk assessment',
   DeleteRiskAssessment: 'Delete riskbedömning',
   CompleteRiskAssessmentConfirmationMessage: 'Are you sure you want to complete the risk assessment? The action cannot be undone when it has been completed.',
   DeleteRiskAssessmentConfirmationMessage: 'Are you sure you want to delete the risk assessment? The action cannot be undone when it has been completed.',
   RiskAssessmentCompleted: 'Risk assessment succesfully completed',
   CouldNotCompleteRiskAssessment: 'Could not complete the risk assessment',
   DetermineRiskAssesmentConfirmationText: 'Are you sure you want to determine the analysis? The action cannot be undone when it has been completed.',
   DetermineAnalysis: 'Determine analysis',
   EditRiskAssesment: 'Edit risk assesment',
   RiskCriteria: 'Risk criteria',
   NotAssessed: 'Not assessed',
   Unacceptable: 'Unacceptable risk',
   Questionable: 'Questionable risk',
   Acceptable: 'Acceptable risk',
   BigRiskShouldBeAddressed: 'Big risk, must be addressed',
   UncertaintyAboutRiskShouldBeAddressed: 'Uncertainty about the risk, should be addressed',
   SmallRiskShouldNotBeAddressed: 'Small risk, not addressed',
   RiskLevel: 'Risk level',
   AnalyseRisk: 'Analyse risk',
   DeleteRiskAnalysisNoAccessMessage: 'You do not have permission to delete this risk analysis',
   VeryHighPriority: 'Very high',
   HighPriority: 'High',
   LowPriority: 'Low',
   VeryLowPriority: 'Very low',

   // SWOT
   Strengths: 'Strengths',
   Weaknesses: 'Weaknesses',
   Opportunities: 'Opportunities',
   Threats: 'Threats',
   Strength: 'Strength',
   Weakness: 'Weakness',
   Opportunity: 'Opportunity',
   Threat: 'Threat',
   TheThreat: 'The Threat',
   SWOT: 'SWOT',
   TimeToAddYourFirstSWOT: 'Time to add your first SWOT',
   Order: 'Order',
   ChangeOrder: 'Ändra ordning',
   ActionProposal: 'Action proposal',
   CreateProposedAction: 'Create action proposal',
   of: 'of',
   ValueInOrderOfImportance: 'Value in order of importance',
   NoSWOTMatchingSelectedFilter: 'No SWOTs matching selected filter',
   Graph: 'Graph',
   NoTypeIdentified: 'No {{type}} are identified',

   // Consequece and probability analysis
   ThreatScenario: 'Threat scenario',
   RiskEvaluation: 'Risk evaluation',
   NewThreat: 'New threat',
   EditThreat: 'Edit threat',
   CurrentThreat: 'Current threat',
   AnalyseDate: 'Analyse date',
   NoThreatsIdentifiedYet: 'No threats identified yet',
   SpecifyCurrentThreat: 'Specify current threat',
   VeryHigh: 'Very high risk',
   High: 'High risk',
   Moderate: 'Moderate risk',
   Low: 'Low risk',
   VeryLow: 'Very low risk',
   Probable: 'Probable',
   Likely: 'Likely',
   Possible: 'Possible',
   LessLikely: 'LessLikely',
   Unlikely: 'Unlikely',
   Severe: 'Severe',
   Serious: 'Serious',
   Significant: 'Significant',
   Mild: 'Mild',
   Negligible: 'Negligible',
   ConsequenceLifeAndHealth: 'Consequence life and health',
   ConsequenceEconomy: 'Consequence economy',
   ConsequenceEnvironment: 'Consequence environment',
   ConsequenceBrand: 'Consequence brand',
   Probability: 'Probability',
   ProbabilityScale: 'Probability scale',
   ProbabilityScaleInfo:
      'The probability scale consists of five levels and is adapted to the criteria of the Swedish Civil Contingencies Agency (MSB) and the Swedish Security Service.',
   ConsequenceLifeAndHealthScale: 'Consequence scale - Life & Health',
   ConsequenceLifeAndHealthScaleInfo:
      'The consequence for life and health can be assessed from two perspectives. Either as a disruption event affecting the entire organization, or as an event where one or more individuals are severely impacted, making it difficult for the organization to achieve its goals. This forms the basis for risk assessment according to this method. If you are assessing, for example, workplace injuries, the scale should include other types of damages, such as wear and tear, noise, vibrations, social unrest, and so on.',
   ConsequenceEconomyScale: 'Consequence scale - Economy',
   ConsequenceEconomyScaleInfo:
      "The economic consequence is measured in monetary terms and is based on the organization's budgeted revenue for the current year. The scale does not take into account financially strong owners or an unusually large cash reserve, but assumes a sound business economy.",
   ConsequenceEnvironmentScale: 'Consequence scale - Environment',
   ConsequenceEnvironmentScaleInfo:
      'When assessing environmental impact, the consequence scale is based on the need for remediation and the extent of damage to soil, water, and air. However, it is recommended to use the same scale as for the economy, which corresponds to the costs of remediation and the extent of the damage. Consider any potential insurance compensation when making the assessment.',
   ConsequenceBrandScale: 'Consequence scale - Brand',
   ConsequenceBrandScaleInfo:
      'The consequence assessment for the brand is based on how the brand is affected in terms of severity, the extent of negative publicity, customer trust, financial impact, and the ability to recover.',

   VeryHighDescription: 'May occur one or more times per year.',
   HighDescription: 'May occur within 1 to 5 years.',
   ModerateDescription: 'May occur within 5 to 10 years.',
   LowDescription: 'May occur within 10 to 50 years.',
   VeryLowDescription: 'May occur less frequently than once every 50 years.',

   OfEstimatedRevenue: 'of estimated revenue',

   ProbableLifeHealthDescription: 'Multiple fatalities and/or severe injuries',
   LikelyLifeHealthDescription: 'Injury requiring advanced medical care. Fatalities may occur',
   PossibleLifeHealthDescription: 'Injury requiring medical care',
   LessLikelyLifeHealthDescription: 'Injury requiring basic care',
   UnlikelyLifeHealthDescription: 'Injury not requiring medical care',

   ProbableEnvironmentDescription: 'Severe remediation, large spread > 20% of estimated revenue',
   LikelyEnvironmentDescription: 'Severe remediation, limited spread > 10% of estimated revenue',
   PossibleEnvironmentDescription: 'Simple remediation, large spread > 5% of estimated revenue',
   LessLikelyEnvironmentDescription: 'Simple remediation, limited spread > 2% of estimated revenue',
   UnlikelyEnvironmentDescription: 'No remediation, limited spread < 2% of estimated revenue',

   ProbableBrandDescription: 'Permanently damaged brand, extensive negative media attention, significant financial losses, threat to business survival.',
   LikelyBrandDescription: 'Risk of losing multiple key customers, serious impact on the brand, long-term effects on customer relationships.',
   PossibleBrandDescription: 'Repeated negative media attention, risk of losing a single major customer and several minor customers.',
   LessLikelyBrandDescription: 'Poor reputation perceived by several customers, national media attention, risk of losing a single minor customer.',
   UnlikelyBrandDescription: 'Temporary poor reputation, brief local media attention. No significant financial impact.',

   // Calendar
   AnnualCalendar: 'Annual calendar',
   Activities: 'Activities',
   Activity: 'Activity',
   TheActivity: 'The activity',
   AreYouSureYouWantToDeleteActivity: 'Are you sure you want to delete the activity?',
   DeleteActivity: 'Delete activity',
   EndDate: 'End date',
   Color: 'Color',
   InvalidColor: 'Invalid color code',
   ChooseColor: 'Click to choose color',
   Comments: 'Comments',
   AddComment: 'Add comment',
   NoComments: 'No comments yet',
   Week: 'Week',
   NoActivitiesInPeriod: 'No activities during this period',
   OverlappingActivities: 'Overlapping activities',
   EditActivity: 'Edit activity',
   PlanActivity: ' Plan new activity',
   PlanActivitesMsg: 'Plan acitivities to see activities in the calendar',
   PlanActivitesPhoneViewMsg: 'Plan activities to see activities in the list',
   StartDate: 'Start date',
   To: 'To',
   OnlySystemAdministratorCanDeleteActivities: 'Only system a administrator can delete activities',

   // Settings
   Settings: 'Settings',
   SettingsAndRegister: 'Settings and register',

   // Risk economy
   RiskEconomy: 'Risc economy',
   FinancialYear: 'Financial year',
   TheFinancialYear: 'The financial year',
   NewFinancialYear: 'New financial year',
   TimeToCreateYourFirstFinancialYear: 'Time to create your first financial year',
   Period: 'Period',
   BudgetedRevenue: 'Budgeted revenue',
   IdentifyCosts: 'Identify costs',
   Budget: 'Budget',
   Result: 'Result',
   Cost: 'Cost',
   TheCost: 'The cost',
   Evaluation: 'Evaluation',
   DamageCosts: 'Damage costs',
   PreventiveCosts: 'Preventive costs',
   InsuranceCosts: 'Insurance costs',
   SecurityAdministration: 'Security administration',
   AllCosts: 'All costs',
   Category: 'Category',
   Post: 'Post',
   NumberOfPosts: 'Number of posts',
   SeePosts: 'See posts',
   AssociatedPosts: 'Associated posts',
   'OriginPost/-s': 'Origin post/-s',
   TotalItem: 'Total {{Item}}',
   Deviation: 'Deviation',
   SummaryDeviation: 'Summary deviation',
   DeleteItemConfirmationMessage: 'Are you sure you want to delete the {{Item}}? The action cannot be undone when it has been completed.',
   FilterByCategory: 'Filter by category',
   FilterOnBudgetOrResult: 'Filter on budget or result',
   Date: 'Date',
   TotalNumberOfPosts: 'Total number of posts',
   TotalBudget: 'Total budget',
   TotalResult: 'Total result',
   TimeToAddYourFirstCost: 'Time to add your first cost',
   Costs: 'Costs',
   AddCost: 'Add cost',
   EditCost: 'Edit cost',
   Action: 'Action',
   CompleteFinancialYear: 'Complete financial year',
   CompleteFinancialYearConfirmationMessage: 'Are you sure you want to complete the financial year? The action cannot be undone when it has been completed.',
   DeleteFinancialYearConfirmationMessage: 'Are you sure you want to delete the financial year? The action cannot be undone when it has been completed.',
   DeleteFinancialYearNoAccessMessage: 'You do not have permission to delete the financial year',
   FinancialYearCompleted: 'Financial year succesfully completed',
   CouldNotCompleteFinancialYear: 'Could not complete the financial year',
   CreatingFinancialYear: 'Creating financial year',
   FinancialYearCreated: 'The financial year has been created',
   ClickContinueToGoToFinancialYear: "Click 'Continue' to open your financial year",
   AddACostToEvaluate: 'Add a cost under the "evaluate costs" tab to be able to evaluate it',

   // Date picker
   January: 'January',
   February: 'February',
   March: 'March',
   April: 'April',
   May: 'May',
   June: 'June',
   July: 'July',
   August: 'August',
   September: 'September',
   October: 'October',
   November: 'November',
   December: 'December',

   Jan: 'Jan',
   Feb: 'Feb',
   Mar: 'Mar',
   Apr: 'Apr',
   MayShort: 'May',
   Jun: 'Jun',
   Jul: 'Jul',
   Aug: 'Aug',
   Sep: 'Sep',
   Oct: 'Oct',
   Nov: 'Nov',
   Dec: 'Dec',

   Monday: 'Monday',
   Tuesday: 'Tuesday',
   Wednesday: 'Wednesday',
   Thursday: 'Thursday',
   Friday: 'Friday',
   Saturday: 'Saturday',
   Sunday: 'Sunday',

   MondayShort: 'M',
   TuesdayShort: 'T',
   WednesdayShort: 'W',
   ThursdayShort: 'T',
   FridayShort: 'F',
   SaturdayShort: 'S',
   SundayShort: 'S',
   GoToToday: 'Go to today',

   // Data classification
   OpenInformation: 'Open information',
   InternalInformation: 'Internal information',
   ConfidentialInformation: 'Confidential information',
   LimitedClassifiedInformation: 'Limited classified information',

   // Switch organisation
   SwitchOrganisation: 'Switch organisation',
   SelectOrganisation: 'Select organisation',
   SuccessfullySwitchedOrganisation: 'Successfully switched organisation',
   CouldNotSwitchOrganisation: 'Could not switch organisation',
   AccountNotInOrganisation: 'Account does not belong to the organisation',

   // Subscription
   Subscription: 'Subscription',
   ModulesAndUsers: 'Modules and users',
   UpgradeSubscription: 'Upgrade subscription',
   ChangeSubscription: 'Change subscription',
   SystemAdmin: 'System admin',
   AdditionalModules: 'Additional modules',
   AdditionalModule: 'Additional module',
   OnlyAdditionalModule: 'Additional module only',
   SubscriptionUpgradeRequiredForPurchaseOfAdditionalModules: 'Subscription upgrade required for purchase of additional modules',
   AllCurrentModulesForOrganisation: 'All current modules for the organisation',
   PurchaseAdditionalModule: 'Purchase additional module',
   Free: 'Free',
   Start: 'Start',
   Base: 'Base',
   Extended: 'Extended',
   Advanced: 'Advanced',
   SeparateModules: 'Separate modules',

   // Demandlevel (formerly Subscription) translation for dropdown
   DEMO: 'Demo',
   LINE_MANAGER: 'Line manager',
   SPECIALIST: 'Specialist',
   CONSULTANT: 'Consultant',
   MANAGEMENT: 'Management',
   STRATEGIC_DEMAND_ASSESSMENT: 'Strategic demand assessment',
   ADD_ON: 'Add-on',

   // Risk management modules
   SWOT_ANALYSIS: 'SWOT analysis',
   SIMPLIFIED_RISK_ANALYSIS: 'Simplified risk analysis',
   CONSEQUENCE_AND_PROBABILITY_ANALYSIS: 'Consequence and probability analysis',

   // Components modules
   DEMAND_COMPLIANCE: 'Demand compliance',
   RISK_MANAGEMENT: 'Risk management',
   RISK_ECONOMY: 'Risk economy',
   CALENDAR: 'Calendar',

   // Modules
   Modules: 'Modules',
   BaseModules: 'Base modules',
   DemandComplianceModules: 'Demand compliance modules',
   RiskManagementModules: 'Risk management modules',

   // Clauses
   Clauses: 'Clauses',

   // Dashboard
   Overview: 'Overview',
   OverviewData: 'Overview data',
   BiggestRisks: 'Biggest risks',
   DoADemandAssessment: 'Do a demand assessment!',
   DoADemandAssessmentDescription: 'Are you complying with all the requirements placed on your business? Find out through a requirements assessment!',
   CreateDemandAssessment: 'Create demand assessment',

   PlanYourCalendar: 'Plan your calendar',
   PlanYourCalendarDescription: 'When should the next requirements assessment be done and when is it time for a risk assessment? Start your planning now!',
   CreateActivity: 'Create activity',

   DoARiskAssessment: 'Do a risk assessment!',
   DoARiskAssessmentDescription: 'Identify your biggest risks through a risk assessment.',
   CreateRiskAssessment: 'Create risk assessment',

   CreateNewFinancialYear: 'Create new financial year',
   CreateNewFinancialYearDescription:
      'The risk economics module lacks a fiscal year and identified costs to produce a diagram here. Get started with risk economics right away!',
   CreateFinancialYear: 'Create financial year',

   // Contact sales representative
   ContactSalesRepresentativeToChangeOrgDetails: 'Contact your sales representative to change your organization details',
   ContactSalesRepresentativeToOrderUsersAndModules: 'Contact your sales representative to order users and modules',

   // Process owner
   NewProcessOwner: 'New process owner',
   TheProcessOwner: 'The process owner',
   ProcessOwnerName: 'Process owner name',
   Processes: 'Processes',
   ProcessOwnerInfo: 'Name which people within the organization are process owners, which affects requirements assessments and risk assessments',
   OnlySystemAdministratorCanDeleteProcessOwners: 'Only a system administrator can delete process owners',
   TheProcessOwnerIsInUseAndCannotBeDeleted: 'The process owner is in use and cannot be deleted',

   // Demand sub type
   EUDirective: 'EU Directive',
   Article: 'Article',
   Law: 'Law',
   Ordinance: 'Ordinance',
   Paragraph: 'Paragraph',

   // Demand area
   Economy: 'Economy',
   WorkEnviroment: 'Work environment',
   Market: 'Market',
   Sustainability: 'Sustainability',
   Quality: 'Quality',
   Staff: 'Staff',
   Security: 'Security',
   Management: 'Management',
   ITLaw: 'IT law',
   Production: 'Production',

   // Export
   Lawlist: 'Lawlist',
   LawRequirements: 'Law requirements',
   PrintDate: 'Print date',
   Source365Robust: 'Source: 365Robust',

   // Terms and conditions
   TermsAndConditions: 'Terms and conditions',
   DownloadTermsAndConditions: 'Download terms and conditions',
   SuccessfullyDownloadedTermsAndConditions: 'Successfully downloaded terms and conditions',
   CouldNotDownloadTermsAndConditions: 'Could not download terms and conditions',

   // Other
   A: 'A',
   An: 'An',
   The: 'The',
}
